<template>
  <div class="details-page">
    <site-header />
    <div class="content-wrapper">
      <div class="article-container">
        <h1 class="article-title">{{ articleData.title || articleData.name }}</h1>
        <div class="article-meta">
          <span class="date">发布时间：{{ formatDate(articleData.createTime) }}</span>

          <!-- <span class="category">分类：{{ articleData.categoryName }}</span> -->
          <span v-if="articleData.writer" class="writer">作者：{{ articleData.writer }}</span>
          <span v-if="articleData.modifyTime" class="modify-time">更新时间：{{ formatDate(articleData.modifyTime) }}</span>
          <span class="views">浏览量：{{ articleData.views || 0 }}</span>
        </div>
        <img v-if="articleData.cover" :src="articleData.cover" class="article-cover" alt="文章封面">

        <div class="article-content" v-html="articleData.contents || articleData.summary"></div>
      </div>
      <!-- Recommended Articles Sidebar -->
      <div class="recommended-articles">
        <h2 class="recommended-title">推荐文章</h2>
        <div class="article-list">
          <template v-if="policyList && policyList.length">
            <div v-for="(item, index) in policyList" :key="item.id || index" class="article-item"
              @click="goToPolicyDetail(item)">
              <img v-if="item.messageImg" :src="item.messageImg" :alt="item.title" class="article-image">
              <div class="article-item-title">{{ item.title }}</div>
              <div class="article-item-date">{{ item.releaseTime }}</div>
            </div>
          </template>
          <template v-else-if="newsListFromHome && newsListFromHome.length">
            <div v-for="(item, index) in newsListFromHome" :key="item.id || index" class="article-item"
              @click="handleNewsClick(item)" style="cursor: pointer;">
              <img :src="item.messageImg" :alt="item.messageName" class="article-image">
              <div class="article-item-title">{{ item.messageName }}</div>
            </div>
          </template>
          <template v-else-if="projectList && projectList.length">
            <div v-for="(item, index) in projectList" :key="item.id || index" class="article-item"
              @click="goToProjectDetails(item)">
              <img :src="item.cover" :alt="item.title" class="article-image">
              <div class="article-item-title">{{ item.title }}</div>
              <div class="article-item-date" v-if="item.itemTime">{{ item.itemTime.split(' ')[0] }}</div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <site-footer />
  </div>
</template>

<script>
import SiteHeader from "@/components/SiteHeader.vue";
import SiteFooter from "@/components/SiteFooter.vue";
import { getNewsMessageById } from "@/api/website";

export default {
  name: "ArticleDetails",
  components: {
    SiteHeader,
    SiteFooter,
    // Breadcrumb
  },
  data() {
    return {
      articleData: {
        title: '',
        categoryName: '',
        createTime: '',
        contents: '',
        cover: ''
      },
      newsListFromHome: [],
      projectList: [],
      policyList: []
    };
  },
  created() {
    this.fetchArticleData();
    if (this.$route.query.newsList) {
      this.newsListFromHome = this.$route.query.newsList;
      console.log('从首页传递过来的新闻列表:', this.newsListFromHome);
    }
    if (this.$route.query.projectList) {
      this.projectList = this.$route.query.projectList;
      console.log('从首页传递过来的项目列表:', this.projectList);
    }
    if (this.$route.query.policyList) {
      this.policyList = this.$route.query.policyList;
      console.log('从政策法规过来的项目列表:', this.policyList);
    }
  },
  watch: {
    '$route.query.id': {
      handler(newId) {
        if (newId) {
          this.fetchArticleData();
        }
      },
      immediate: true
    }
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
        date.getDate()
      ).padStart(2, "0")}`;
    },
    goToProjectDetails(item) {
      this.$router.push({
        path: '/details',
        query: {
          item: item,
          projectList: this.projectList
        }
      });
    },
    goToPolicyDetail(item) {
      this.$router.push({
        name: 'details',
        query: {
          id: item.id,
          title: item.title,
          releaseTime: item.releaseTime,
          policyList: this.policyList
        }
      });
    },
    handleNewsClick(item) {
      console.log('点击的文章数据:', item);
      console.log('当前的新闻列表:', this.newsListFromHome);
      this.goToNewsDetail(item);
    },
    goToNewsDetail(item) {
      if (!item.id) {
        console.error('文章ID不存在');
        return;
      }

      this.$router.push({
        path: '/details',
        query: {
          id: item.id,
          newsList: this.newsListFromHome
        }
      });
    },
    async fetchArticleData() {
      const query = this.$route.query;
      let articleData = null;

      if (query.id) {
        try {
          const res = await getNewsMessageById({ id: query.id });
          if (res && res.code === 200 && res.data) {
            articleData = res.data;
          }
        } catch (error) {
          console.error("获取文章详情失败:", error);
        }
      } else if (query.notice) {
        articleData = query.notice;
      } else if (query.news) {
        articleData = query.news;
      } else if (query.item) {
        articleData = query.item;
      } else if (query.teacher) {
        articleData = query.teacher;
      } else if (query.event) {
        articleData = query.event;
      } else {
        articleData = query;
      }

      if (articleData) {
        this.articleData = {
          title: articleData.messageName || articleData.title || '',
          categoryName: articleData.source || articleData.categoryName || '未分类',
          createTime: articleData.createTime || '',
          contents: articleData.messageContent || articleData.contents || '',
          cover: articleData.messageImg || articleData.cover || '',
          name: articleData.messageName || articleData.name || '',
          summary: articleData.messageDigest || articleData.summary || '',
          writer: articleData.createUserName || articleData.writer || '',
          modifyTime: articleData.modifyTime || '',
          views: articleData.seq || 0
        };
      }
    }
  },
  mounted() {
    // 接收路由参数
    // const query = this.$route.query;
    // console.log('接收到的路由参数:', 
    //  query
    // );
  }
};
</script>

<style scoped>
.details-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  width: 100%;
}

.content-wrapper {
  flex: 1;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  gap: 40px;
  align-items: flex-start;
  box-sizing: border-box;
}

.article-container {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  flex-grow: 1;
  max-width: 800px;
  overflow-x: hidden;
  box-sizing: border-box;
}

.article-title {
  font-size: 24px;
  color: #333;
  margin-bottom: 25px;
  text-align: center;
}

.article-meta {
  color: #666;
  font-size: 14px;
  margin-bottom: 30px;
  text-align: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.article-meta>span {
  margin: 0 10px;
}

.article-content {
  line-height: 1.8;
  color: #333;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.article-content :deep(img) {
  max-width: 100% !important;
  width: auto !important;
  height: auto !important;
  display: block;
  margin: 10px auto;
}

.article-content :deep(p) {
  margin-bottom: 1em;
  max-width: 100%;
}

.article-content :deep(table) {
  max-width: 100%;
  overflow-x: auto;
  display: block;
}

.article-content :deep(pre) {
  max-width: 100%;
  overflow-x: auto;
}

.article-content :deep(video) {
  max-width: 100% !important;
  height: auto !important;
}

.article-cover {
  max-width: 100%;
  height: auto;
  margin: 20px auto;
  display: block;
  border-radius: 4px;
}

.recommended-articles {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  width: 300px;
  flex-shrink: 0;
  margin-top: 0;
}

.recommended-title {
  font-size: 22px;
  color: #2d437c;
  font-weight: 600;
  margin-bottom: 20px;
  text-align: left;
  border-bottom: 2px solid #eee;
  padding-bottom: 15px;
}

.article-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.article-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  cursor: pointer;
  transition: background-color 0.2s ease;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.article-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.article-item:hover {
  background-color: #fafafa;
}

.article-image {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 10px;
}

.article-item-title {
  font-size: 14px;
  color: #333;
  text-align: left;
  flex-grow: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.article-item-date {
  font-size: 12px;
  color: #666;
  margin-top: 5px;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .details-page {
    width: 100vw;
    overflow-x: hidden;
  }

  .content-wrapper {
    flex-direction: column;
    padding: 10px;
    gap: 20px;
    width: 100%;
    max-width: 100vw;
    box-sizing: border-box;
  }

  .article-container {
    max-width: 100%;
    width: 100%;
    padding: 15px;
    border-radius: 8px;
    overflow-x: hidden;
    box-sizing: border-box;
  }

  .article-title {
    font-size: 20px;
    margin-bottom: 20px;
    text-align: left;
    word-wrap: break-word;
  }

  .article-meta {
    font-size: 12px;
    margin-bottom: 20px;
    padding-bottom: 15px;
    text-align: left;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .article-meta > span {
    margin: 0;
  }

  .article-content {
    font-size: 15px;
    line-height: 1.7;
    width: 100%;
    overflow-x: hidden;
  }

  .article-content :deep(img) {
    max-width: 100% !important;
    width: 100% !important;
    height: auto !important;
    object-fit: contain;
  }

  .article-content :deep(p) {
    word-break: break-word;
  }

  .article-cover {
    margin: 15px 0;
    max-width: 100% !important;
    width: 100% !important;
    height: auto !important;
  }

  .recommended-articles {
    width: 100%;
    padding: 20px;
    margin-top: 0;
    box-sizing: border-box;
  }

  .recommended-title {
    font-size: 18px;
    margin-bottom: 15px;
    padding-bottom: 12px;
  }

  .article-list {
    gap: 12px;
  }

  .article-item {
    padding-bottom: 12px;
  }

  .article-image {
    height: 120px;
    width: 100%;
    object-fit: cover;
  }

  .article-item-title {
    font-size: 13px;
    word-break: break-word;
  }

  .article-item-date {
    font-size: 11px;
  }
}

@media screen and (max-width: 480px) {
  .content-wrapper {
    padding: 8px;
    max-width: 100vw;
  }

  .article-container {
    padding: 12px;
    width: 100%;
  }

  .article-title {
    font-size: 18px;
  }

  .article-meta {
    font-size: 11px;
  }

  .article-content {
    font-size: 14px;
  }

  .article-content :deep(img) {
    max-width: 100% !important;
    width: 100% !important;
  }

  .recommended-articles {
    padding: 15px;
  }

  .recommended-title {
    font-size: 16px;
  }

  .article-image {
    height: 100px;
    width: 100%;
  }
}
</style>
